import {Injectable, Output} from '@angular/core';
import {User} from "./entities/user/user";

@Injectable()
export class Auth {
    private _user: User;
    private _authToken: string;
    @Output() isAuthenticated: boolean = false;

    get user(): User {
        return this._user;
    }

    set user(value: User) {
        this._user = value;

        if ( this._user == null || this._user.id == 0 ) {
            this.isAuthenticated = false;
            this.authToken = "";
        }
        else {
            this.isAuthenticated = true;
        }
    }


    get authToken(): string {
        if ( ! this._authToken ) {
            this._authToken = localStorage.getItem("auth-token");
        }

        return this._authToken;
    }

    set authToken(value: string) {
        if ( value == "" ) {
            localStorage.removeItem("auth-token");
        }
        else {
            localStorage.setItem("auth-token", value);
        }

        this._authToken = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.auth.ts